import { createContext } from 'react';

export const SSEEventContext = createContext({});
